// extracted by mini-css-extract-plugin
export default {"container":"light_header-module__container--22kyU","wrapper":"light_header-module__wrapper--3JaEL"};